import React, { useState } from "react";
import {
  capitalize,
  CurrencyFormat,
  formatDate,
} from "../../../../../../components/helpers";
import { convertToRoman } from "../../../../../campaign/helpers";
import { AiFillEye } from "react-icons/ai";
import DetailCampaignDialog from "../../../../components/DetailCampaignDialog";

const ExtensionTab = ({ data }) => {
  const { extensions } = data;

  const [offerDetailDialog, setOfferDetailDialog] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState({});

  const handleOpenDetailOffer = (offer) => {
    setSelectedOffer(convertOffer(offer));
    setOfferDetailDialog(true);
  };

  const handleCloseDetailOffer = () => {
    setOfferDetailDialog(false);
    setSelectedOffer({});
  };

  const convertOffer = (data) => {
    console.log("data", data);
    let convertedOffer = {};
    convertedOffer = {
      offer: {
        name: data?.promo_extension?.name,
        gadaiType:
          data?.promo_extension?.gadai_type === "pick_up"
            ? "Jemput Gadai"
            : "Reguler",
        category: data?.promo_extension?.promo_extension_products
          .map((e) => {
            return e.product_category.name;
          })
          .join(", "),
        outlet:
          data?.promo_extension?.gadai_type !== "pick_up"
            ? data?.promo_extension?.promo_extension_outlets
                .map((e) => {
                  return e.outlet.name;
                })
                .join(", ")
            : "-",
        tenorType: capitalize(data?.promo_extension?.tenor_type),
        paymentType:
          data?.promo_extension?.payment_type === "balloon_payment"
            ? "Balloon Payment"
            : "Reguler",
        minLoan: "Rp " + data?.promo_extension?.min_loan_rupiah,
        maxLoan: "Rp " + data?.promo_extension?.max_loan_rupiah,
        tenor: data?.promo_extension?.promo_extension_tenors
          .map((e) => {
            return `${e.days} Hari`;
          })
          .join(", "),
        capitalLoan:
          data?.promo_extension?.capital_loan_rupiah != 0
            ? "Rp " + data?.promo_extension?.capital_loan_rupiah
            : data?.promo_extension?.capital_loan_percentage + "%",
        feeAdmin:
          data?.promo_extension?.fee_admin_rupiah != 0
            ? "Rp " + data?.promo_extension?.fee_admin_rupiah
            : data?.promo_extension?.fee_admin_percentage + "%",
        feeSavingInsurance:
          data?.promo_extension?.fee_saving_assurance_rupiah != 0
            ? "Rp " + data?.promo_extension?.fee_saving_assurance_rupiah
            : data?.promo_extension?.fee_saving_assurance_percentage + "%",
        revaluation:
          data?.promo_extension?.revaluation_rupiah != 0
            ? "Rp " + data?.promo_extension?.revaluation_rupiah
            : data?.promo_extension?.revaluation_percentage + "%",
        isAllowChangeValuation: data?.promo_extension?.is_able_input_revaluation
          ? "Iya"
          : "Tidak",
        gracePeriod: data?.promo_extension?.grace_period + " Hari",
        type: "extension",
      },
    };
    return convertedOffer;
  };
  return (
    <>
      {extensions && extensions.length > 0 ? (
        extensions.map((extension, index) => {
          return (
            <div key={index} className="detail-bold-text">
              <div className="mb-2">
                Perpanjangan {convertToRoman(index + 1)}
              </div>
              <div className="row detail-row">
                <div className="col-4">Biaya Sewa Modal</div>
                <div className="col-md-auto">:</div>
                <div className="col">
                  Rp {CurrencyFormat(extension?.capital_loan)}
                </div>
              </div>
              <div className="row detail-row">
                <div className="col-4">Biaya Administrasi</div>
                <div className="col-md-auto">:</div>
                <div className="col">
                  Rp {CurrencyFormat(extension?.fee_admin)}
                </div>
              </div>
              <div className="row detail-row">
                <div className="col-4">Biaya Simpan & Asuransi</div>
                <div className="col-md-auto">:</div>
                <div className="col">
                  Rp {CurrencyFormat(extension?.fee_saving_assurance)}
                </div>
              </div>
              <div className="row detail-row">
                <div className="col-4">Nilai Revaluasi</div>
                <div className="col-md-auto">:</div>
                <div className="col">
                  Rp {CurrencyFormat(extension?.revaluation)}
                </div>
              </div>
              <div className="row detail-row">
                <div className="col-4">Tanggal Jatuh Tempo</div>
                <div className="col-md-auto">:</div>
                <div className="col">{formatDate(extension?.new_due_date)}</div>
              </div>
              <div className="row detail-row">
                <div className="col-4">Offer yang Digunakan</div>
                <div className="col-md-auto">:</div>
                <div className="col">
                  {extension?.promo_extension?.name}
                  <AiFillEye
                    onClick={() => handleOpenDetailOffer(extension)}
                    style={{
                      fontSize: 24,
                      color: "#2C465C",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div style={{ fontWeight: "600" }}>Belum Ada Perpanjangan</div>
      )}
      <DetailCampaignDialog
        visible={offerDetailDialog}
        handleCancel={handleCloseDetailOffer}
        data={selectedOffer}
      />
    </>
  );
};

export default ExtensionTab;
